import Editor from "./index.vue";

Editor.install = Vue => Vue.component(Editor.componentName, Editor);

export default Editor;
